export default function accordion() {
  return {
    itemOpen: false,

    init() {
      // Open a matching accordion item when the page loads with an anchor hash.
      const anchorId = window.location.hash.slice(1);

      if (!anchorId) {
        return;
      }

      const target = document.getElementById(anchorId);

      // Ignore hashes that point somewhere outside this accordion instance.
      if (!target || !this.$el.contains(target)) {
        return;
      }

      this.itemOpen = anchorId;

      this.$nextTick(() => {
        // Delay slightly so direct hash visits get a clearer open-then-scroll cue.
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200);
      });
    },

    setItemOpen(anchorId) {
      if (this.itemOpen === anchorId) {
        this.itemOpen = false;
        history.replaceState(null, '', window.location.pathname + window.location.search);
        return;
      }

      this.itemOpen = anchorId;
      history.replaceState(null, '', '#' + anchorId);
    },
  };
}
